module.exports = __webpack_public_path__ + "img/background2-mobile.da8aad35.jpg";